var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "28.979614px",
    viewBox: "0 0 21 28.979614",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sheets"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 7.93706L20.9996 27.1131C20.9996 28.1457 20.1653 28.9796 19.1323 28.9796L1.86726 28.9796C0.834307 28.9796 0 28.1457 0 27.1131L0 1.86654C0 0.833987 0.834307 0 1.86726 0L13.0595 0L20.9996 7.93706Z",
    id: "Shape",
    fill: "#23A566",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0903 14.4274L5.90721 14.4274C5.57803 14.4274 5.31128 14.694 5.31128 15.0231L5.31128 23.0169C5.31128 23.3459 5.57803 23.6126 5.90721 23.6126L15.0959 23.6126C15.4251 23.6126 15.6919 23.3459 15.6919 23.0169L15.6919 15.0287C15.6862 14.6997 15.4194 14.4274 15.0903 14.4274L15.0903 14.4274ZM6.50297 18.2627L9.90263 18.2627L9.90263 19.7775L6.50297 19.7775L6.50297 18.2627ZM11.095 18.2627L14.4947 18.2627L14.4947 19.7775L11.095 19.7775L11.095 18.2627ZM14.4947 17.071L11.095 17.071L11.095 15.6243L14.4947 15.6243L14.4947 17.071ZM9.90263 15.6243L9.90263 17.071L6.50297 17.071L6.50297 15.6243L9.90263 15.6243ZM6.50297 20.9746L9.90263 20.9746L9.90263 22.4213L6.50297 22.4213L6.50297 20.9746ZM11.095 22.4213L11.095 20.9746L14.4947 20.9746L14.4947 22.4213L11.095 22.4213Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1268 7.64764L20.9999 13.2132L20.9999 7.98805L17.1008 5.72436L14.1268 7.64764Z",
    id: "Shape",
    fill: "#000000",
    fillOpacity: 0.19,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 7.93706L14.9267 7.93706C13.8938 7.93706 13.0594 7.10308 13.0594 6.07052L13.0594 0L20.9996 7.93706Z",
    id: "Shape",
    fill: "#8ED1B1",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/sheets.76aa350f34de384212720a663288ac13.svg";
export { ForwardRef as ReactComponent };